import { UNDOABLE_TYPE } from './enums/undoable.type.enum';
import { Reducer } from 'redux';

export function undoable(reducer: Reducer<any>, type: UNDOABLE_TYPE) {
	// Call the reducer with empty action to populate the initial state
	const initialState: UndoableState = {
		past: [],
		present: reducer(undefined, {type: '__INIT__'}),
		future: []
	};

	const undoableType: UNDOABLE_TYPE = type;
	// Return a reducer that handles undo and redo
	return function(state = initialState, action: any) {
		const { past, present, future } = state;
		switch (action.type) {

			case 'UNDO':
				if ( undoableType !== action.undoableType ) {
					return state;
				}
				if ( past.length === 0 ) {
					return state;
				} else {
					const previous = past[past.length - 1];
					const newPast = past.slice(0, past.length - 1);
					return {
						past: newPast,
						present: previous,
						future: [ present, ...future ]
					};
				}

			case 'REDO':
				if ( undoableType !== action.undoableType ) {
					return state;
				}

				if ( future.length === 0 ) {
					return state;
				} else {
					const next = future[0];
					const newFuture = future.slice(1);
					return {
						past: [ ...past, present ],
						present: next,
						future: newFuture
					};
				}


			case 'GOTOSTATE':
				if ( undoableType !== action.undoableType ) {
					return state;
				}
				if ( past.indexOf(action.state) !== -1 ) { 	// go into the past
					const newFuture = [ present, ...future ];

					for ( let l: number = past.length, i: number = l - 1; i >= 0; i-- ) {
						if ( past[i] === action.state ) {
							const newPast = past.slice(0, i);
							return {
								past: newPast,
								present: past[i],
								future: newFuture
							};
						} else {
							newFuture.unshift( past[i] );
						}
					}
				} else if ( future.indexOf(action.state) !== -1 ) { 	// go back to the future
					const newPast = [ ...past, present ];

					for ( let i = 0, l: number = future.length; i < l; i++ ) {
						if ( future[i] === action.state ) {
							const newFuture = future.slice(i + 1, l);
							return {
								past: newPast,
								present: future[i],
								future: newFuture
							};
						} else {
							newPast.push( future[i] );
						}
					}
				}
				return state;

			default:
				// Delegate handling the action to the passed reducer

				const newPresent = reducer(present, action);

				if (present === newPresent) {
					return state;
				}

				newPresent.timestamp = Date.now();
				newPresent.dateTime = new Date();
				if ( undoableType === action.undoableType && action.history === 'reset' ) {
					return {
						past: [],
						present: newPresent,
						future: []
					};
				}

				return {
					past: [ ...past, present ],
					present: newPresent,
					future: []
				};
		}
	};
}

export interface UndoableState {
	past: any[];
	present: any;
	future: any[];
}
